module.exports = __webpack_public_path__ + "gambia.svg?84b484d46c6bab5efd114d8e47723c36";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/gambia.svg
// module id = 171
// module chunks = 10